import React, { useState } from 'react';

import createForm from '@swf/components/Forms/Form';
import Input from '@swf/components/Inputs/Input';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import Translation from '@swf/components/Translation/Translation';
import { UserClubRole } from '@swf/core/types/Poker';
import { FormattedUTCDate, useGetCurrentClub } from '@swf/poker';

import type { Props } from '../Container';

import { TXTCLI_Announcement_Whiteboard, TXTCLI_Send } from './Announcements.messages.json';
import styles from './Announcements.scss';
import useAnnouncementStream from './hooks/useAnnouncementStream';
import useClubMessageRequest from './hooks/useClubMessageRequest';

export interface FormFields {
  announcement: string;
}

const Form = createForm<FormFields>();

const Announcements: React.FC<Props> = (props) => {
  const { clubId } = props.match.params;
  const [loading, setLoading] = useState(false);
  const { state } = useAnnouncementStream({ clubId });
  const { handleSubmit } = useClubMessageRequest({ clubId, setLoading });
  const { roleForUser } = useGetCurrentClub(clubId);

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>
        <Translation {...TXTCLI_Announcement_Whiteboard} />
      </h3>
      {state && (
        <>
          <div className={styles.date}>
            <b>{state.userId}</b>
            <FormattedUTCDate
              utcDate={`${state.created}`}
              options={{ isRelative: true, dateStyle: 'long', timeStyle: 'short' }}
            />
          </div>
          <div className={styles.announcement}>{state.content}</div>
        </>
      )}
      {(roleForUser === UserClubRole.Manager || roleForUser === UserClubRole.Admin) && (
        <Form
          className={styles.form}
          onSubmit={handleSubmit}
          initialValues={{ announcement: '' }}
          render={({ values: { announcement } }) => {
            const value = announcement ?? '';
            const isEmpty = value.replaceAll(' ', '') === '';

            return (
              <>
                <Input id="announcement" label="" showValidationTick={false} type="textarea" />
                <StarsButton
                  block
                  disabled={loading || isEmpty}
                  type="submit"
                  translation={TXTCLI_Send}
                />
              </>
            );
          }}
        />
      )}
    </div>
  );
};

export default Announcements;
